import PropTypes from 'prop-types';
import { ACTIONS } from '../Calculator';
import './style.css';

export const ButtonDigit = ({ dispatch, digit, double }) => {
  return (
    <button
      onClick={() =>
        dispatch({ type: ACTIONS.ADD_DIGIT, payload: { digit: digit } })
      }
      className={`button
    ${double ? 'double' : ''}`}
    >
      {digit}
    </button>
  );
};

ButtonDigit.propTypes = {
  digit: PropTypes.node,
  dispatch: PropTypes.func,
  double: PropTypes.bool,
};
